export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Portal/index.js
// module id = 461
// module chunks = 121